import React, { useState, useEffect } from "react";

import gql from "graphql-tag";
import * as actionTypes from "../redux/actions";
import { spinnerService } from "@chevtek/react-spinners";
import { connect } from "react-redux";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import moment from "moment";
import { utilGetVehicleImage, utilGetCustomer } from "../common/util";
import { toast } from "react-toastify";
import { myGetCustomerExtended } from "../data/customQueries";
let regType = "";
const InspectionPage = props => {
  let [data, setData] = useState([]);
  const [registeredInspectionType, setRegisteredInspectionType] = useState("");
  const getData = async () => {
    try {
      let { client, user, profile } = props;
      // if (profile !== null) {
      //   setRegisteredInspectionType(profile.registeredInspectionType);
      // }
      if ((user === null) | (user === undefined))
        return alert("user obj not found");
      let vehicleDispData = [];
      let dueDate = moment(new Date()).add(15, "days");
      spinnerService.show("mySpinner");
      /*
      res = (await client.query({
        query: gql(mainDashboardQuery),
        fetchPolicy: `network-only`,
        variables: { id: custId, dueDate: dueDate, limit: 1000 }
      })).data.getCustomer;
      */
      let res = "";
      //if (profile === undefined || profile === "" || profile === null) {
      res = await utilGetCustomer(user, client);
      props.storeProfile(res);
      // } else res = profile;
      //
      regType = res.registeredInspectionType;

      if (res.vehicles.items !== null) {
        let index = 0;
        res.vehicles.items.forEach(item => {
          //
          index++;
          let vehDefectCount = 0;
          let redTagCheck = false;
          let dispObj = {
            key: index,
            redTag: false,
            name: item.customerVehicleId,
            VIN: item.VIN,
            id: item.id,
            sort: 0,
            vehCategory: item.vehicleType
              ? item.vehicleType.vehicleCategory
              : "",
            inspectionDue: false,
            make: item.make,
            model: item.model,
            deactivateBIT: item.deactivateBIT,
            deactivateDOT: item.deactivateDOT,
            // nextDueDate:
            //   item.nextInspectionDue !== null
            //     ? item.nextInspectionDue[0].nextDueDate
            //     : "Not Available",
            defectCount: 0
          };
          if (res.registeredInspectionType !== "FEDERAL_BIT") {
            if (
              !(
                item.nextInspectionDue === undefined ||
                item.nextInspectionDue === null
              )
            ) {
              if (item.nextInspectionDue.length > 0) {
                dispObj.nextDue = ["", null, undefined].includes(
                  item.nextInspectionDue[0].nextDueDate
                )
                  ? null
                  : item.nextInspectionDue[0].nextDueDate;
              }
            }
          } else if (res.registeredInspectionType === "FEDERAL_BIT") {
            const date1 =
              item.nextInspectionDue && item.nextInspectionDue.length > 0
                ? item.nextInspectionDue[0].nextDueDate
                : null;
            const date2 =
              item.nextInspectionDue && item.nextInspectionDue.length > 1
                ? item.nextInspectionDue[1].nextDueDate
                : null;

            if (
              ["", null, undefined].includes(date1) &&
              ["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = null;
            } else if (
              ["", null, undefined].includes(date1) &&
              !["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = date2;
            } else if (
              !["", null, undefined].includes(date1) &&
              ["", null, undefined].includes(date2)
            ) {
              dispObj.nextDue = date1;
            } else if (
              !["", null, undefined].includes(date1) &&
              !["", null, undefined].includes(date2)
            ) {
              if (moment(new Date(date2)).isBefore(new Date(date1))) {
                dispObj.nextDue = date2;
              } else {
                dispObj.nextDue = date1;
              }
            }
          }
          res.defectsByStatus.items.map(defect => {
            if (defect.vehicleId === item.id) {
              if (defect.redTag === true) dispObj.redTag = true;
              dispObj.defectCount++;
              dispObj.defectStatus = defect.status;
            }
          });
          // dispObj.defectCount = vehDefectCount;
          if (res.inspectionsByDueDate && res.inspectionsByDueDate.length > 0) {
            res.inspectionsByDueDate.items.map(inspection => {
              if (inspection.vehicle && inspection.vehicle.id == item.id) {
                dispObj.inspectionDue = true;
                dispObj.nextInspectionDue = inspection.nextInspectionDue;
                dispObj.inspectionId = inspection.id;
              }
            });
          }
          vehicleDispData.push(dispObj);
        });
      }
      let sortCounter = 0;
      vehicleDispData.sort((a, b) => {
        if (a.vehCategory > b.vehCategory) {
          sortCounter++;
          a.sort = sortCounter;
          return 1;
        }
        b.sort = sortCounter;
        return -1;
      });
      setData(vehicleDispData);
      spinnerService.hide("mySpinner");
    } catch (error) {
      spinnerService.hide("mySpinner");
    }
  };

  useEffect(() => {
    getData();
  }, []);
  const handleStartInsp = item => {
    if (props.match.params.type === "insp") {
      if (regType === "FEDERAL_BIT") {
        if (item.deactivateBIT && item.deactivateDOT) {
          return toast.error(
            "BOTH BIT & DOT for Specified Vehicle Are Deactivated"
          );
        } else if (item.deactivateBIT && !item.deactivateDOT) {
          props.history.push(`/inspection/new/details/${item.id}`, {
            deactivated: "BIT"
          });
        } else if (!item.deactivateBIT && item.deactivateDOT) {
          props.history.push(`/inspection/new/details/${item.id}`, {
            deactivated: "DOT"
          });
        } else {
          props.history.push(`/inspection/new/details/${item.id}`, {
            deactivated: "None"
          });
        }
      }
      if (regType === "FEDERAL") {
        if (item.deactivateDOT) {
          return toast.error("DOT for Specified Vehicle is Deactivated");
        } else {
          props.history.push(`/inspection/new/details/${item.id}`, {
            deactivated: "None"
          });
        }
      }
      if (regType === "BIT") {
        if (item.deactivateBIT) {
          return toast.error("BIT for Specified Vehicle is Deactivated");
        } else {
          props.history.push(`/inspection/new/details/${item.id}`, {
            deactivated: "None"
          });
        }
      }
    } else if (props.match.params.type === "otf")
      props.history.push(`/inspection/new/start/inspection/${item.id}/otf`);
    // if (item.deactivateBIT && regType !== "FEDERAL") {
    //   return toast.error(
    //     "We Are Sorry, BIT for Specified Vehicle is Deactivated"
    //   );
    // } else {
    //   if (props.match.params.type === "insp")
    //     props.history.push(`/inspection/new/details/${item.id}`);
    //   else if (props.match.params.type === "otf")
    //     props.history.push(`/inspection/new/start/inspection/${item.id}/otf`);
    //   //toast.show("Inspection route not properly defined. Re-try or contact support.")
    //   else props.history.push(`/inspection/new/details/${item.id}`);
    // }
  };
  return (
    <div style={{ margin: "auto 0" }}>
      <h3>Select a Vehicle</h3>
      {data.map((item, i) => {
        let src = utilGetVehicleImage(item.vehCategory);
        {
          /* let nextDueDate = "Not given";
        if (item.nextInspectionDue !== undefined) {
          item.nextInspectionDue.map(dateItem => {
            nextDueDate +=
              dateItem.INSPECTIONTYPE + ": " + dateItem.nextDueDate;
          });
        } */
        }
        return (
          <List style={styles.root} component="nav" key={i}>
            <ListItem
              alignItems="flex-start"
              style={{
                backgroundColor: "white",
                cursor: "pointer"
              }}
            >
              <img src={src} height={70} width={100} />
              <ListItemText
                primary={`Vehicle Id : ${item.name}`}
                onClick={() => handleStartInsp(item)}
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      className={styles.inline}
                      color="textPrimary"
                    >
                      {item.nextDue && (
                        <span>{`Next Inspection : ${item.nextDue}`}</span>
                      )}
                      <span
                        style={{ marginLeft: 15 }}
                      >{`Defect Count : ${item.defectCount}`}</span>
                    </Typography>
                    <Typography
                      component="span"
                      className={styles.inline}
                      color="textPrimary"
                    >
                      <span>{`VIN : ${item.VIN}`}</span>
                      <span
                        style={{ marginLeft: 15 }}
                      >{`Make : ${item.make}`}</span>
                      <span
                        style={{ marginLeft: 15 }}
                      >{`Model : ${item.model}`}</span>
                      <div>
                        {item.deactivateBIT && regType !== "FEDERAL" && (
                          <span style={{ marginLeft: "2%", color: "red" }}>
                            <Chip label="BIT Deactivated" color="secondary" />
                          </span>
                        )}
                        {item.deactivateDOT && regType !== "BIT" && (
                          <span style={{ marginLeft: "2%", color: "red" }}>
                            <Chip label="DOT Deactivated" color="secondary" />
                          </span>
                        )}
                      </div>
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        );
      })}
    </div>
  );
};

const styles = {
  btn: {
    backgroundColor: "skyBlue"
  },
  root: {
    width: "100%",
    maxWidth: 500
  },
  inline: {
    display: "inline"
  }
};

const mapStateToProps = state => {
  return {
    user: state.config.user,
    loading: state.config.loading,
    client: state.config.client,
    profile: state.config.profile,
    vehicleGrid: state.vehicles.vehicleGrid
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeVehicleGrid: data => dispatch(actionTypes.storeVehicleGrid(data)),
    storeProfile: data => dispatch(actionTypes.storeProfile(data))

    // storeUser: data => dispatch(actionTypes.storeUser(data)),
    // storeClient: data => dispatch(actionTypes.storeClient(data))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InspectionPage);



// WEBPACK FOOTER //
// ./src/inspection/inspetionsPage.jsx